const en = {
  welcome: `Welcome`,
  description: `UXCP is the only existing public tool that analyzes how people think by looking at their cognitive biases. You create profiles ("Personas") by naming them and selecting which biases they tend to show. These profiles can represent individuals or groups - from specific people to broad categories like "Female Audience" or "Canadians." The system examines 105 different cognitive biases across 63 management questions.`,
  descriptionLink: {
    info: 'You can find a complete explanation of this tool ',
    title: 'on Medium via this link.',
    target: '_target',
    href: 'https://medium.com/@alexanyanwolf/creating-user-persona-with-cognitive-biases-and-ux-core-cb5a03a897a9',
  },
  exampleText: 'Persona examples',
  exampleMobileText: 'Persona examples',
  examples: [
    {
      title: 'Steve Jobs',
      link: 'https://google.com/search?q=Steve Jobs',
    },
    {
      title: 'Warren Buffett',
      link: 'https://google.com/search?q=Warren Buffett',
    },
    {
      title: 'Barak Obama',
      link: 'https://google.com/search?q=Barak Obama',
    },
    {
      title: 'Uber_user_Middle_East',
      link: 'https://google.com/search?q=Uber_user_Middle_East',
    },
    {
      title: 'iPhone_user_Somali',
      link: 'https://google.com/search?q=iPhone_user_Somali',
    },
    {
      title: 'Twitter_crypto_influencer',
      link: 'https://google.com/search?q=Twitter_crypto_influencer',
    },
    {
      title: 'Twitter_politician',
      link: 'https://google.com/search?q=Twitter_politician',
    },
  ],
  title: `Persona builder`,
  sectionTitle: `Add biases to Persona`,
  analyzeTeamMemeber: `Analyze as a team member?`,
  analyzeTeamMemeberTooltip: `When enabled the system will outline the most persona-relevant biases from those you selected.`,
  personaInputLabel: 'Persona name',
  personaInputPlaceholder: 'John Doe',
  personaInputMobilePlaceholder: 'Persona name',
  biasSearchPlaceholder: 'Search',
  biasSearchTip: 'Input the name of the bias or the part of its description',
  addButtonText: 'Add',
  showAllText: 'Show all',
  yes: `Yes`,
  no: `No`,
  subSectionTitle: `Insights`,
  suggestedQuestionsTitle: `Suggested questions to explore`,
  suggestedQuestionsDescription: `The system has found one or more questions that are not related to the biases you’ve selected, but appears in Persona-relevant questions too often. We recommend you look into these questions in your research as well.`,
  teamRelatedInsightsTitle: `eam Member Insights`,
  teamRelatedInsightsDescription1: `The option "Analyze as a team member" is enabled. In this section, you will see the biases that you have to focus on in the first place while considering your cooperation with `,
  teamRelatedInsightsDescription2: ` as a team member.`,
  questionHighRelevancyText: `High relevance to Persona`,
  questionMediumRelevancyText: `Medium relevance to Persona`,
  questionLowRelevancyText: `Low relevance to Persona`,
  noData: `No data`,
  pieChartSectionTitle: `Persona questions per product stage`,
  personaRelatedQuestionsTitle: `Persona-relevant questions`,
  relevancyLevel: `Relevance level`,
  relevancyLevelHint: `Relevance is calculated based on the number of similar questions found in selected biases.`,
  all: `All`,
  highPriority: `High`,
  mediumPriority: `Medium`,
  lowPriority: `Low`,
  and: `And`,
  other: `other`,
  pageTitle: `Page`,
  questionLabel: `question`,
  appearsIn1: 'Appears in ',
  appearsInPersonaRelatedQuestions: '% of the Persona-relevant questions (',
  appearsInSelectedBiases: '% of the selected biases (',
  appearsIn2: ' out of ',
  appearsIn3: ')',
  pieChartPlaceholder: 'Select the product stage to begin',
  biasPlaceholder: 'Add bias to begin',
  copyURL: 'Copy URL',
  copied: 'Copied!',
  mobileDisclimer: 'Persona builder is available only on Desktop',
  searchResultText1: 'found',
  searchResultText2: 'result',
  stage: 'stage',
  biasPopupCustomTip:
    'Click on the number to open the bias in UX Core (in a new tab)',
};

export default en;
